import Image from 'next/image'
import React from 'react'
import { HTMLAttributes } from 'react'
import styled from 'styled-components'

export type DefaultIconProps = HTMLAttributes<HTMLSpanElement>

export const IconWrapper = styled.span``

export const FacebookIcon = () => (
  <IconWrapper>
    <Image
      src="/images/icons/facebook-n.svg"
      width={30}
      height={30}
      alt="Facebook"
    />
  </IconWrapper>
)
export const InstagramIcon = () => (
  <IconWrapper>
    <Image
      src="/images/icons/instagram-n.svg"
      width={30}
      height={30}
      alt="Instagram"
    />
  </IconWrapper>
)
export const LinkedInIcon = () => (
  <IconWrapper>
    <Image
      src="/images/icons/linkedin-n.svg"
      width={30}
      height={30}
      alt="LinkedIn"
    />
  </IconWrapper>
)
